import styles from "./Divider.module.scss";
export default function Divider() {
  return <div className={`${styles.line}`}></div>;
}
